import React from 'react';
import styled from 'styled-components';
import Breadcrumb from '../menus/Breadcrumb';
import Accordion from '../widgets/Accordion';
import AddButton from '../button/AddButton';
import DragInfoText from '../texts/DragInfoText';
import Sortable from '../interactions/Sortable';

const breadcrumbData = [
    {
        title: "기본관리",
        link: ""
    },
    {
        title: "보관함",
        link: ""
    },
    {
        title: "안내",
        link: ""
    }
];

const AccordionContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
`

const firstCategory = [
    {
        id: 1,
        order: 1,
        title: "펜션 이용안내",
        isOn: true,
        thumbnail: null,
        isHeadquarters: true
    },
    {
        id: 2,
        order: 2,
        title: "펜션 유의사항",
        isOn: true,
        thumbnail: null,
        isHeadquarters: true
    },
    {
        id: 3,
        order: 3,
        title: "객실 이용안내",
        isOn: true,
        thumbnail: null,
        isHeadquarters: true
    },
    {
        id: 4,
        order: 4,
        title: "객실 유의사항",
        isOn: false,
        thumbnail: null,
        isHeadquarters: true
    }
];

// 보관함 > 안내
const Template9 = () => {
    return (
        <div>
            <Breadcrumb data={breadcrumbData} />
            <AccordionContainer>
                <Accordion title="안내설정" isHeadquarters boxCount={1}>
                    <AddButton title="안내추가" />
                    <Sortable itemList={firstCategory} />
                    <DragInfoText />
                </Accordion>
            </AccordionContainer>
        </div>
    );
};

export default Template9;